jQuery(function ($) {
    var rememberme = $('#rememberme'),
        links = $('#social-login-container').find('a'),
        form = $('form[name="comment-form"]'),
        fetch = $('#fetch-more');

    if (rememberme.length && links.length) {
        rememberme.on('change', function () {
            if (rememberme.is(':checked')) {
                $.each(links, function (idx, elem) {
                    var href = elem.getAttribute('href');
                    if (href.indexOf('&rememberme=yes') === -1) {
                        elem.setAttribute('href', href + '&rememberme=yes');
                    }
                });
            } else {
                $.each(links, function (idx, elem) {
                    var href = elem.getAttribute('href'),
                        pos = href.indexOf('&rememberme=yes');
                    if (pos > -1) {
                        elem.setAttribute('href', href.substr(0, pos));
                    }
                });
            }
        });
    }

    if (form.length) {
        var button = form.find('button[type="submit"]'),
            title = $('#comment-title');

        form.on('submit', function (e) {
            e.preventDefault();
            $.ajax(form.attr('action'), {
                data: form.serialize(),
                beforeSend: function () {
                    button.attr('disabled', 'disabled');
                },
                success: function (response) {
                    if (response.success && response.data.hasOwnProperty('comment_html')) {
                        var html = response.data['comment_html'], comment;
                        if ('string' === typeof html && html.length) {
                            comment = ($(html).insertAfter(title));
                            if (comment) {
                                $([document.documentElement, document.body]).animate({
                                    scrollTop: title.offset().top
                                }, 500);
                            }
                        }
                    } else if (Array.isArray(response.data) &&
                        response.data.length &&
                        response.data[0].hasOwnProperty('code') &&
                        response.data[0].hasOwnProperty('message')
                    ) {
                        alert(response.data[0].code + ': ' + response.data[0].message);
                    } else {
                        console.error(response);
                    }
                },
                error: function (jqXhr, textStatus, errorThrown) {
                    alert(jqXhr.status + ': ' + errorThrown);
                },
                complete: function () {
                    button.removeAttr('disabled');
                    form.trigger('reset');
                }
            });
        });
    }

    if (fetch.length) {
        var commentsWrap = $('#comments-wrap'),
            currentPage = 2,
            fetchNonce = $('#fetch_nonce').val();

        fetch.on('click', function () {
            if (currentPage > 0) {
                $.ajax(form.attr('action'), {
                    data: {
                        action: 'cheil_fetch_comments',
                        nonce: fetchNonce,
                        page: currentPage,
                        post_id: $('#post_id').val(),
                    },
                    beforeSend: function () {
                        fetch.attr('disabled', 'disabled');
                    },
                    success: function (response) {
                        if (response.success && response.data.hasOwnProperty('comment_html')) {
                            var html = response.data['comment_html'];
                            if ('string' === typeof html && html.length) {
                                commentsWrap.append(html);
                                currentPage += 1;
                            } else {
                                currentPage = -1;
                                fetch.find('span').text('마지막입니다');
                            }
                        } else if (Array.isArray(response.data) &&
                            response.data.length &&
                            response.data[0].hasOwnProperty('code') &&
                            response.data[0].hasOwnProperty('message')
                        ) {
                            alert(response.data[0].code + ': ' + response.data[0].message);
                        } else {
                            console.error(response);
                        }
                    },
                    error: function (jqXhr, textStatus, errorThrown) {
                        alert(jqXhr.status + ': ' + errorThrown);
                    },
                    complete: function () {
                        if (currentPage > 0) {
                            fetch.removeAttr('disabled');
                        }
                    }
                });
            }
        });
    }
});